/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from "react";
import { Helmet } from "react-helmet";

export interface IHelmetLink {
    link: string;
    rel: string;
}

export interface IHelmetCompProps {
    helmetLinks?: IHelmetLink[];
}

const DEFAULT_LINKS = [
    {
        link:
            "https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i|Nunito:300,300i,400,400i,600,600i,700,700i|Poppins:300,300i,400,400i,500,500i,600,600i,700,700i",
        rel: "stylesheet"
    },
    {
        link: "https://unpkg.com/aos@2.3.1/dist/aos.css",
        rel: "stylesheet"
    },
    {
        link: "https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.css",
        rel: "stylesheet"
    },
    {
        link:
            "https://cdn.jsdelivr.net/npm/glightbox/dist/css/glightbox.min.css",
        rel: "stylesheet"
    },
    {
        link:
            "https://cdn.jsdelivr.net/npm/remixicon@2.5.0/fonts/remixicon.css",
        rel: "stylesheet"
    }
];

export const HelmetComp = ({ helmetLinks }: IHelmetCompProps) => {
    const _links = [...DEFAULT_LINKS, ...helmetLinks];
    return (
        <Helmet>
            {_links?.map((helmet, index) => (
                <link
                    key={`helmet-${index}`}
                    href={helmet.link}
                    rel={helmet.rel}
                />
            ))}
        </Helmet>
    );
};

HelmetComp.defaultProps = {
    helmetLinks: []
};
